// extracted by mini-css-extract-plugin
export default {"image":"T3-z","loaded":"U3-z"};